export default __webpack_public_path__ + "static/media/W25P2009_05.d203c045.png";